var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"actionsModule"}},[_c('div',{staticClass:"card mb-3 p-3"},[_c('action-list-component',{attrs:{"view":"table"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }